export const STYLES = `
/* Accent is themeable from the host page via CSS custom properties (they pierce
   the shadow boundary). Defaults keep the original purple; e.g. set
   \`--aqua-accent: #E55B1F\` on the <aqua-widget> element to brand it. */
:host { all: initial; font-family: system-ui, sans-serif; display: block; width: 100%; color: #1a1a2e; --aqua-accent: #6c5ce7; --aqua-accent-soft: #f3f1ff; }
* { box-sizing: border-box; }
/* Fill the host element, which fills its parent — the host page controls width/placement
   by sizing the wrapping container (or the <aqua-widget> element) however it likes. */
.card { border: 1px solid #e2e2ef; border-radius: 12px; padding: 16px; width: 100%; background: #fff; }
.tabs { display: flex; gap: 4px; margin-bottom: 12px; }
.tab { flex: 1; padding: 8px; border: 1px solid #e2e2ef; background: #f7f7fb; border-radius: 8px; cursor: pointer; font-size: 14px; }
.tab[aria-selected="true"] { background: var(--aqua-accent); color: #fff; border-color: var(--aqua-accent); }
.drop { border: 2px dashed #c9c9e0; border-radius: 10px; padding: 24px; text-align: center; cursor: pointer; color: #555; }
.drop.over { border-color: var(--aqua-accent); background: var(--aqua-accent-soft); }
button.act { background: var(--aqua-accent); color: #fff; border: none; border-radius: 8px; padding: 9px 14px; cursor: pointer; font-size: 14px; }
button.act.ghost { background: #f0f0f7; color: #333; }
button.act:disabled { opacity: .5; cursor: not-allowed; }
.row { display: flex; gap: 8px; align-items: center; margin-top: 12px; flex-wrap: wrap; }
.field { display: flex; flex-direction: column; gap: 4px; margin-bottom: 10px; }
.field label { font-size: 13px; font-weight: 600; }
.field input { padding: 7px; border: 1px solid #ccc; border-radius: 6px; font-size: 14px; }
select {
  width: 100%;
  padding: 9px 36px 9px 12px;
  border: 1px solid #d4d4e0;
  border-radius: 8px;
  font-size: 14px;
  line-height: 1.3;
  color: #1a1a2e;
  background-color: #fff;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%23888888' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 12px center;
  -webkit-appearance: none; -moz-appearance: none; appearance: none;
  cursor: pointer;
  transition: border-color .15s ease, box-shadow .15s ease;
}
select:hover { border-color: #b3b3c7; }
select:focus { outline: none; border-color: var(--aqua-accent); box-shadow: 0 0 0 3px color-mix(in srgb, var(--aqua-accent) 22%, transparent); }
.mute { display: flex; align-items: center; gap: 8px; padding: 6px 0; border-bottom: 1px solid #f0f0f0; font-size: 14px; }
.mute .val { color: #888; margin-left: auto; max-width: 180px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.check { display: flex; align-items: center; gap: 8px; padding: 6px 0; font-size: 14px; }
.check .ok { color: #2ecc71; } .check .miss { color: #e74c3c; }
.badge { display: inline-block; padding: 4px 10px; border-radius: 999px; font-weight: 700; font-size: 13px; }
.badge.valid { background: #e6f9ee; color: #1b8f4d; }
.badge.invalid { background: #fdeaea; color: #c0392b; }
.err { background: #fdeaea; color: #c0392b; padding: 8px 10px; border-radius: 8px; font-size: 13px; margin-top: 10px; }
.muted { color: #888; font-size: 13px; overflow-wrap: anywhere; word-break: break-word; }
.log { font-family: monospace; font-size: 12px; background: #f7f7fb; border-radius: 8px; padding: 8px; max-height: 160px; overflow: auto; margin-top: 10px; white-space: pre-wrap; }
`
